module.exports = __webpack_public_path__ + "static/media/unsupported_logo.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=static/media/[name].[ext]!./src/assets/images/unsupported_logo.png
// module id = 6
// module chunks = 1